import React from "react";
import { Radio, ExternalLink, QrCode as QrIcon } from "lucide-react";

function buildQrUrl(value) {
  const safe = encodeURIComponent(value || "https://estel.pt");
  // Free, no-key QR generator
  return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&bgcolor=141414&color=00F0FF&qzone=1&data=${safe}`;
}

export default function StreamingPanel({ streaming, gameName, accent = "#00F0FF" }) {
  const hasUrl = streaming && streaming.url;
  const url = hasUrl ? streaming.url : "";
  const isLive = streaming?.is_live;
  const platform = streaming?.platform || "YouTube";

  return (
    <section
      data-testid="streaming-panel"
      className="relative border border-white/10 bg-[#141414]"
    >
      <div className="grid md:grid-cols-[1fr_auto] gap-6 p-6 md:p-8">
        <div className="flex flex-col justify-between gap-6">
          <div>
            <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em]" style={{ color: accent }}>
              <Radio className="h-3.5 w-3.5" />
              Transmissão Oficial
            </div>
            <h3 className="font-display text-3xl sm:text-4xl uppercase tracking-wider mt-2">
              {isLive ? (
                <span className="flex items-center gap-3">
                  <span className="h-3 w-3 bg-[#FF3B30] pulse-live" />
                  Ao Vivo Agora
                </span>
              ) : (
                "Acompanha o Stream"
              )}
            </h3>
            <p className="text-sm text-white/60 mt-2 max-w-md">
              {gameName} é transmitido em {platform}. Verifica abaixo o link ou
              aponta a câmara do telemóvel para o código QR.
            </p>
          </div>

          {hasUrl ? (
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              data-testid="streaming-link"
              className="inline-flex items-center justify-center gap-2 self-start border border-[#00F0FF] bg-[#00F0FF] text-black px-5 py-3 text-sm font-bold uppercase tracking-wider hover:bg-white hover:border-white transition-colors"
            >
              Abrir {platform}
              <ExternalLink className="h-4 w-4" />
            </a>
          ) : (
            <div
              data-testid="streaming-placeholder"
              className="inline-flex items-center gap-2 self-start border border-dashed border-white/15 px-4 py-3 text-xs uppercase tracking-[0.2em] text-white/40"
            >
              Link a definir pela organização
            </div>
          )}
        </div>

        <div className="flex flex-col items-center justify-center gap-3">
          <div
            className="p-3 border border-white/10 bg-black"
            data-testid="qr-code-box"
          >
            <img
              src={buildQrUrl(url || window.location.href)}
              alt={`QR Code ${gameName}`}
              width={180}
              height={180}
              className="block"
            />
          </div>
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-white/40">
            <QrIcon className="h-3 w-3" />
            Scan para abrir
          </div>
        </div>
      </div>
    </section>
  );
}
